import json from './sprite.js';

export default {
    handle: 'SP_SPS6-HitByBall',
    label: 'es_SPS6-HitByBall_234684067',
    json,
};
